var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContrabassSheet = function SvgContrabassSheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.929 16.988a2.345 2.345 0 0 1-.614-4.043C10.576 10.81 8.412 8.87 6 9c-2.412-.13-4.577 1.81-4.315 3.945a2.345 2.345 0 0 1-.614 4.043.46.46 0 0 0-.321.446c.031 2.3 2.464 4.413 5.081 4.4h.338c2.617.01 5.05-2.1 5.081-4.4a.46.46 0 0 0-.321-.446M6 13.5V.75m0 22.5V21M4.5 5.25h3m-3-3h3m5.793 11.826a1.02 1.02 0 0 0 .957.937l7.408-.029a1.02 1.02 0 0 0 .951-.943l.629-4.5a1.26 1.26 0 0 0-.22-.911.92.92 0 0 0-.739-.4l-8.7.034a.92.92 0 0 0-.737.4 1.26 1.26 0 0 0-.212.913zM18 12.75v10.5m-3.75-.03L18 20.25l3.75 3"
  })));
};
export default SvgContrabassSheet;